module.exports = __webpack_public_path__ + "img/download.99b7d615.jpeg";